/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';

export const useScrollShadow = (scrollRef: React.RefObject<HTMLDivElement>) => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) return;

    let timeout: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      setIsScrolling(true);

      // Clear previous timeout and set a new one
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsScrolling(false);
      }, 200); // 200ms debounce to detect stop scroll
    };

    scrollElement.addEventListener('scroll', handleScroll);
    return () => {
      scrollElement.removeEventListener('scroll', handleScroll);
      clearTimeout(timeout);
    };
  }, [scrollRef]);

  return isScrolling;
};
